import { AxiosInstance } from "axios";
import { AuthLoginResponseService } from "../auth/AuthenticationServices.type";
import {
  AddParticularPatientRequestService,
  AddParticularPatientResponseService,
  GetParticularPatientProfileResponseService,
  UpdateParticularPatientRequestService,
  UpdateParticularPatientResponseService,
} from "./ParticularPatient.type";

export default class ParticularPatientService {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  // GET PARTICULAR PATIENT'S PROFILE
  public async getParticularPatientProfile(): Promise<GetParticularPatientProfileResponseService> {
    const url: string = `users/particular_client/profile`;
    return this.axios.get(url, {
      method: "get",
    });
  }

  // CREATE A NEW PARTICULAR PATIENT
  public async addParticularPatient(
    data: AddParticularPatientRequestService,
  ): Promise<AddParticularPatientResponseService> {
    const { repeatPassword, ...rest } = data;
    const url: string = "users/register/particular_client";
    return this.axios.post(url, rest);
  }

  // UPDATE PARTICULAR PATIENT'S INFORMATION
  public async updateParticularPatient(
    data: UpdateParticularPatientRequestService,
  ): Promise<void> {
    const {
      fullAddress,
      gender,
      id,
      phoneNumber,
      postalCode,
      sex,
      userId,
      ...rest
    } = data;
    const url: string = `/users/particular_client/${id}`;
    return this.axios.patch(url, rest);
  }
}
